import { forwardRef } from "react";
import type { LucideProps } from "lucide-react";

export const TimelineIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ size = 24, color = "currentColor", strokeWidth, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2505 13C16.217 13 17.0005 13.7835 17.0005 14.75V19.25C17.0005 20.2165 16.217 21 15.2505 21H3.75048C2.78398 21 2.00048 20.2165 2.00048 19.25V14.75C2.00048 13.7835 2.78398 13 3.75048 13H15.2505ZM21.0008 14.8989L21.0005 20.25C21.0005 20.6642 20.6647 21 20.2505 21C19.8708 21 19.557 20.7178 19.5073 20.3518L19.5005 20.25L19.5001 14.9117C19.7324 14.9694 19.9754 15 20.2255 15C20.4936 15 20.7535 14.9648 21.0008 14.8989ZM15.2505 14.5H3.75048C3.61241 14.5 3.50048 14.6119 3.50048 14.75V19.25C3.50048 19.3881 3.61241 19.5 3.75048 19.5H15.2505C15.3886 19.5 15.5005 19.3881 15.5005 19.25V14.75C15.5005 14.6119 15.3886 14.5 15.2505 14.5ZM20.2503 10.0919C21.3041 10.0919 22.1583 10.9462 22.1583 12C22.1583 13.0538 21.3041 13.9081 20.2503 13.9081C19.1965 13.9081 18.3422 13.0538 18.3422 12C18.3422 10.9462 19.1965 10.0919 20.2503 10.0919ZM15.2461 3C16.2126 3 16.9961 3.7835 16.9961 4.75V9.25C16.9961 10.2165 16.2126 11 15.2461 11H3.74609C2.7796 11 1.99609 10.2165 1.99609 9.25V4.75C1.99609 3.83183 2.7032 3.07881 3.60257 3.0058L3.74609 3H15.2461ZM15.2461 4.5H3.74609L3.68877 4.5066C3.57833 4.53251 3.49609 4.63165 3.49609 4.75V9.25C3.49609 9.38807 3.60802 9.5 3.74609 9.5H15.2461C15.3842 9.5 15.4961 9.38807 15.4961 9.25V4.75C15.4961 4.61193 15.3842 4.5 15.2461 4.5ZM20.2505 3C20.6302 3 20.944 3.28215 20.9937 3.64823L21.0005 3.75L21.0008 9.10113C20.7535 9.03516 20.4936 9 20.2255 9C19.9754 9 19.7324 9.03061 19.5001 9.08829L19.5005 3.75C19.5005 3.33579 19.8363 3 20.2505 3Z"
        fill={color}
      />
    </svg>
  )
);

TimelineIcon.displayName = "TimelineIcon";
